export default __webpack_public_path__ + "static/media/NoHand.3200696b.png";